import { BulletinsTypes } from './types';

interface CommentProps {
  bidding_comment: {
    bidding_id: string | number;
    message: string;
  };
}

interface FetchBulletinBiddingsParams {
  bulletin_id: string;
  page?: number;
  per_page?: number;
  passive_load?: boolean;
  companyId?: number | null;
  filters?: Record<string, unknown>;
  isSearch?: boolean;
  ordem?: 'match';
}

export const fetchBulletins = () => {
  return {
    types: [
      BulletinsTypes.FETCH_BULLETINS_REQUEST,
      BulletinsTypes.FETCH_BULLETINS_SUCCESS,
      BulletinsTypes.FETCH_BULLETINS_FAILURE,
    ],
    promise: (client: any) => client.get('boletim_web/public/boletins.json'),
  };
};

export const fetchBulletinsRepresented = (companyId: number) => {
  return {
    types: [
      BulletinsTypes.FETCH_BULLETINS_REPRESENTED_REQUEST,
      BulletinsTypes.FETCH_BULLETINS_REPRESENTED_SUCCESS,
      BulletinsTypes.FETCH_BULLETINS_REPRESENTED_FAILURE,
    ],
    promise: (client: any) =>
      client.get('boletim_web/public/boletins.json', { params: { companyId } }),
    companyId,
  };
};

export const fetchBulletinContent = (filter_id: number | null, month: Date | null) => {
  return {
    types: [
      BulletinsTypes.FETCH_BULLETIN_CONTENT_REQUEST,
      BulletinsTypes.FETCH_BULLETIN_CONTENT_SUCCESS,
      BulletinsTypes.FETCH_BULLETIN_CONTENT_FAILURE,
    ],
    promise: (client: any) =>
      client.get('boletim_web/bulletin_filter_content', { params: { filter_id, month } }),
    filter_id,
  };
};

export const fetchBulletinContentById = (bulletin_filter_id: number) => {
  return {
    types: [
      BulletinsTypes.FETCH_BULLETIN_CONTENT_BY_ID_REQUEST,
      BulletinsTypes.FETCH_BULLETIN_CONTENT_BY_ID_SUCCESS,
      BulletinsTypes.FETCH_BULLETIN_CONTENT_BY_ID_FAILURE,
    ],
    promise: (client: any) =>
      client.get('boletim_web/bulletin_filter_content', { params: { bulletin_filter_id } }),
  };
};

export const fetchBulletinBiddings = (params: FetchBulletinBiddingsParams) => {
  const {
    bulletin_id,
    page = 1,
    per_page = 50,
    passive_load = false,
    companyId,
    filters,
    isSearch = false,
    ordem,
  } = params;

  const apiFilters: Record<string, unknown> = {};
  if (filters) {
    if (filters.objeto) apiFilters.objeto = filters.objeto;
    if (filters.notWord) apiFilters.notWord = filters.notWord;
    if (Array.isArray(filters.states) && filters.states.length > 0)
      apiFilters.states = filters.states;
    if (Array.isArray(filters.cities) && filters.cities.length > 0)
      apiFilters.cities = filters.cities;
    if (filters.validityStart) apiFilters.validityStart = filters.validityStart;
    if (filters.validityEnd) apiFilters.validityEnd = filters.validityEnd;
    if (filters.orgao) apiFilters.orgao = filters.orgao;
    if (Array.isArray(filters.situations) && filters.situations.length > 0)
      apiFilters.bidding_groups = filters.situations;
    if (Array.isArray(filters.status) && filters.status.length > 0)
      apiFilters.status = filters.status;
  }

  return {
    types: [
      BulletinsTypes.FETCH_BULLETIN_BIDDINGS_REQUEST,
      BulletinsTypes.FETCH_BULLETIN_BIDDINGS_SUCCESS,
      BulletinsTypes.FETCH_BULLETIN_BIDDINGS_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`boletim_web/public/boletins/${bulletin_id}/biddings.json`, {
        params: {
          page,
          per_page,
          ...apiFilters,
          ...(companyId ? { companyId } : {}),
          ...(ordem ? { ordem } : {}),
        },
      }),
    bulletin_id,
    current_page: page,
    per_page,
    passive_load,
    isSearch,
  };
};

interface FetchBulletinFollowupsParams {
  bulletin_id: string;
  page?: number;
  per_page?: number;
  passive_load?: boolean;
  filters?: Record<string, unknown>;
  isSearch?: boolean;
}

export const fetchBulletinFollowups = (
  bulletinIdOrParams: string | FetchBulletinFollowupsParams,
  page: number = 1,
  per_page: number = 50,
  passive_load: boolean = false,
) => {
  const isParamsObject = typeof bulletinIdOrParams !== 'string';
  const bulletin_id = isParamsObject ? bulletinIdOrParams.bulletin_id : bulletinIdOrParams;
  const resolvedPage = isParamsObject ? bulletinIdOrParams.page ?? 1 : page;
  const resolvedPerPage = isParamsObject ? bulletinIdOrParams.per_page ?? 50 : per_page;
  const resolvedPassiveLoad = isParamsObject
    ? bulletinIdOrParams.passive_load ?? false
    : passive_load;
  const filters = isParamsObject ? bulletinIdOrParams.filters : undefined;
  const isSearch = isParamsObject ? bulletinIdOrParams.isSearch ?? false : false;

  const apiFilters: Record<string, unknown> = {};
  if (filters) {
    if (filters.objeto) apiFilters.objeto = filters.objeto;
    if (filters.notWord) apiFilters.notWord = filters.notWord;
    if (Array.isArray(filters.states) && filters.states.length > 0)
      apiFilters.states = filters.states;
    if (Array.isArray(filters.cities) && filters.cities.length > 0)
      apiFilters.cities = filters.cities;
    if (filters.publicationStart) apiFilters.publicationStart = filters.publicationStart;
    if (filters.publicationEnd) apiFilters.publicationEnd = filters.publicationEnd;
    if (filters.orgao) apiFilters.orgao = filters.orgao;
    if (Array.isArray(filters.esfera) && filters.esfera.length > 0)
      apiFilters.esfera = filters.esfera;
    if (Array.isArray(filters.status) && filters.status.length > 0)
      apiFilters.status = filters.status;
  }

  return {
    types: [
      BulletinsTypes.FETCH_BULLETIN_FOLLOWUPS_REQUEST,
      BulletinsTypes.FETCH_BULLETIN_FOLLOWUPS_SUCCESS,
      BulletinsTypes.FETCH_BULLETIN_FOLLOWUPS_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`boletim_web/public/boletins/${bulletin_id}/followups`, {
        params: {
          page: resolvedPage,
          per_page: resolvedPerPage,
          ...apiFilters,
        },
      }),
    bulletin_id,
    current_page: resolvedPage,
    per_page: resolvedPerPage,
    passive_load: resolvedPassiveLoad,
    isSearch,
  };
};

export const createFavoriteBulletin = (
  bidding_id: string,
  contact_name: string,
  bulletin_id: number,
  companyId: number | null = null,
) => {
  const data = {
    bidding_id,
    companyId,
  };
  return {
    types: [
      BulletinsTypes.CREATE_BIDDING_FAVORITE_REQUEST,
      BulletinsTypes.CREATE_BIDDING_FAVORITE_SUCCESS,
      BulletinsTypes.CREATE_BIDDING_FAVORITE_FAILURE,
    ],
    bidding_id,
    contact_name,
    bulletin_id,
    companyId,
    promise: (client: any) => client.post('/minhas_licitacoes/favorites', data),
  };
};

export const destroyFavoriteBulletin = (
  bidding_id: string,
  contact_name: string,
  bulletin_id: number,
  companyId: number | null = null,
) => {
  const params = {
    data: {
      bidding_id,
      companyId,
    },
  };

  return {
    types: [
      BulletinsTypes.DESTROY_BIDDING_FAVORITE_REQUEST,
      BulletinsTypes.DESTROY_BIDDING_FAVORITE_SUCCESS,
      BulletinsTypes.DESTROY_BIDDING_FAVORITE_FAILURE,
    ],
    bidding_id,
    contact_name,
    bulletin_id,
    companyId,
    promise: (client: any) => client.delete(`/minhas_licitacoes/favorites/${bidding_id}`, params),
  };
};

export const createCommentBulletin = (
  bidding_id: string | number,
  contact_name: string,
  data: CommentProps,
  profileId: number,
  bulletin_id: number,
) => {
  return {
    types: [
      BulletinsTypes.CREATE_COMMENT_REQUEST,
      BulletinsTypes.CREATE_COMMENT_SUCCESS,
      BulletinsTypes.CREATE_COMMENT_FAILURE,
    ],
    bidding_id,
    contact_name,
    profileId,
    bulletin_id,
    promise: (client: any) => client.post('/minhas_licitacoes/comments', data),
  };
};

export const destroyCommentBulletin = (
  bidding_id: string | number,
  comment_id: string | number,
  bulletin_id: number,
) => {
  return {
    types: [
      BulletinsTypes.DESTROY_COMMENT_REQUEST,
      BulletinsTypes.DESTROY_COMMENT_SUCCESS,
      BulletinsTypes.DESTROY_COMMENT_FAILURE,
    ],
    bidding_id,
    comment_id,
    bulletin_id,
    promise: (client: any) => client.delete(`/minhas_licitacoes/comments/${comment_id}`),
  };
};

export const createBulletinManaged = (
  bidding_id: number,
  bulletin_id: number,
  companyId: number,
) => {
  const data = {
    bidding_id,
    companyId,
  };
  return {
    types: [
      BulletinsTypes.CREATE_MANAGED_REQUEST,
      BulletinsTypes.CREATE_MANAGED_SUCCESS,
      BulletinsTypes.CREATE_MANAGED_FAILURE,
    ],
    bidding_id,
    bulletin_id,
    promise: (client: any) => client.post('/gerenciar_licitacoes/gerenciar', data),
  };
};

export const destroyBulletinManaged = (
  bidding_id: number,
  bulletin_id: number,
  companyId: number,
  contact_client_id: number,
) => {
  const params = {
    data: {
      bidding_id,
      bulletin_id,
      companyId,
      contact_client_id,
    },
  };
  return {
    types: [
      BulletinsTypes.DESTROY_MANAGED_REQUEST,
      BulletinsTypes.DESTROY_MANAGED_SUCCESS,
      BulletinsTypes.DESTROY_MANAGED_FAILURE,
    ],
    bidding_id,
    bulletin_id,
    contact_client_id,
    promise: (client: any) =>
      client.delete(`/gerenciar_licitacoes/gerenciar/${bidding_id}`, params),
  };
};

export const createViewedBiddingBulletin = (
  bidding_id: string,
  contact_name: string,
  bulletin_id: number,
  companyId: number | null = null,
) => {
  const data = {
    bidding_id,
    companyId,
    bulletin_id,
  };
  return {
    types: [
      BulletinsTypes.CREATE_VIEWED_BIDDING_REQUEST,
      BulletinsTypes.CREATE_VIEWED_BIDDING_SUCCESS,
      BulletinsTypes.CREATE_VIEWED_BIDDING_FAILURE,
    ],
    bidding_id,
    contact_name,
    bulletin_id,
    companyId,
    promise: (client: any) => client.post('/minhas_licitacoes/viewed_biddings', data),
  };
};

export const destroyViewedBulletin = (
  bidding_id: string,
  contact_name: string,
  bulletin_id: number,
  companyId: number | null = null,
) => {
  const params = {
    data: {
      bidding_id,
      companyId,
      bulletin_id,
    },
  };

  return {
    types: [
      BulletinsTypes.DESTROY_VIEWED_BIDDING_REQUEST,
      BulletinsTypes.DESTROY_VIEWED_BIDDING_SUCCESS,
      BulletinsTypes.DESTROY_VIEWED_BIDDING_FAILURE,
    ],
    bidding_id,
    contact_name,
    bulletin_id,
    companyId,
    promise: (client: any) =>
      client.delete(`/minhas_licitacoes/viewed_biddings/${bidding_id}`, params),
  };
};

export const markAllBulletinsAsRead = (companyId: number, filterId: number | null = null) => {
  const payload: { companyId: number; filter_id?: number } = { companyId };
  if (filterId) payload.filter_id = filterId;

  return {
    types: [
      BulletinsTypes.MARK_ALL_BULLETINS_READ_REQUEST,
      BulletinsTypes.MARK_ALL_BULLETINS_READ_SUCCESS,
      BulletinsTypes.MARK_ALL_BULLETINS_READ_FAILURE,
    ],
    companyId,
    promise: (client: any) => client.post('/boletim_web/public/boletins/mark_all_as_read', payload),
  };
};

export const getOverview = (id: string) => {
  return {
    types: [
      BulletinsTypes.OVERVIEW_REQUEST,
      BulletinsTypes.OVERVIEW_SUCCESS,
      BulletinsTypes.OVERVIEW_FAILURE,
    ],
    promise: (client: any) => client.get(`/boletim_web/public/boletins/${id}/overview`),
  };
};

export const sendIaMessage = (
  content: string,
  bulletinFilterId: number,
  history: Array<{ role: string; content: string }> = [],
) => {
  return {
    types: [
      BulletinsTypes.SEND_IA_MESSAGE_REQUEST,
      BulletinsTypes.SEND_IA_MESSAGE_SUCCESS,
      BulletinsTypes.SEND_IA_MESSAGE_FAILURE,
    ],
    content,
    promise: (client: any) =>
      client.post('/chatbots/bulletin_ia_chat/messages', {
        content,
        bulletin_filter_id: bulletinFilterId,
        history,
      }),
  };
};

export const clearIaMessages = () => ({
  type: BulletinsTypes.CLEAR_IA_MESSAGES,
});

export const clearIaToolAction = () => ({
  type: BulletinsTypes.CLEAR_IA_TOOL_ACTION,
});

export const setIaMessages = (messages: Array<{ role: string; content: string }>) => ({
  type: BulletinsTypes.SET_IA_MESSAGES,
  messages,
});

export const setIaAppliedFilter = (iaAppliedFilter: {
  name: string;
  chatHistory: Array<{ role: string; content: string }>;
}) => ({
  type: BulletinsTypes.SET_IA_APPLIED_FILTER,
  iaAppliedFilter,
});

export const clearIaAppliedFilter = () => ({
  type: BulletinsTypes.CLEAR_IA_APPLIED_FILTER,
});
